import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export type StepBodyContainerProps = PropsWithChildren & {
  showBorder?: boolean;
};

export const StepBodyContainer: FC<StepBodyContainerProps> = ({
  showBorder,
  children,
  ...props
}) => {
  return (
    <Container $showBody={showBorder ?? false} {...props}>
      {children}
    </Container>
  );
};

const Container = styled.div<{ $showBody: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.iwMobile} {
    padding: 16px;
    ${(p) => (p.$showBody ? `border: 3px dashed ${COLORS.systemSky100};` : '')}
    ${(p) => (p.$showBody ? `border-radius: 12px;` : '')}
  }
`;
